import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { collectorRequest, type CollectorSummary } from '../../services/api/collector';
export function CollectorRecap({ year }: { year: number }) {
  const { user } = useAuth();
  const [data, setData] = useState<{ owner: number; year: number; value: CollectorSummary } | null>(
    null
  );
  useEffect(() => {
    let current = true;
    if (user)
      void collectorRequest<CollectorSummary>('summary', {}, { year: String(year) })
        .then((value) => {
          if (current) setData({ owner: Number(user.id), year, value });
        })
        .catch(() => undefined);
    return () => {
      current = false;
    };
  }, [user, year]);
  if (!data || data.owner !== Number(user?.id) || data.year !== year) return null;
  return (
    <section className="my-6 rounded-2xl border border-white/10 p-6">
      <p className="text-sm text-amber-200">Private collection · {year}</p>
      <h2 className="mt-2 text-xl font-semibold">{data.value.entries} entries worth keeping</h2>
      <p className="mt-2 text-zinc-400">
        {data.value.linked_cars} linked Bilt cars. Photo spots remain separate from verified
        encounter statistics and aren’t included in shared recaps.
      </p>
      <Link
        className="inline-flex min-h-11 items-center text-amber-200 underline"
        to={`/passport?year=${year}`}
      >
        Revisit your cars
      </Link>
    </section>
  );
}
